module.exports = __webpack_public_path__ + "img/Panther.cbf7d9ee.jpg";